<template>
  <li :class="[baseCss, 'pa-1']">
    <a :is="$parent.tag" :title="title" :to="to" :href="to" :target="$parent.target" :class="['outline-none', $parent.underline ? 'underline' : 'underline-none']">
      <slot />
    </a><span v-html="$parent.delimiter" :class="[`${baseCss}-delimiter`, 'px-1']" />
  </li>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'BreadcrumbsItem',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('breadcrumbs-item')
    }
  },
  props: {
    to: {
      type: String,
      required: true
    },
    title: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/breadcrumbs-item/breadcrumbs-item.vue